export const logo = require("./logo.png");
export const logoSimple = require("./logoSimple.png");
